/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'

interface UiTableCellTextProps {
    children: React.ReactNode|React.ReactNode[]
    className?: string
    size?: 'sm' | 'xs'
}

export const UiTableCellTextPrimary: React.FC<UiTableCellTextProps> = (
    props
) => {
    return (
        <span
            className={clsx(
                'UiTableCellTextPrimary font-medium text-gray-900 dark:text-gray-100',
                props.size === 'xs' ? 'text-xs' : 'text-sm',
                props.className
            )}
        >
            {props.children}
        </span>
    )
}

export const UiTableCellTextSecondary: React.FC<UiTableCellTextProps> = (
    props
) => {
    return (
        <span
            className={clsx(
                'UiTableCellTextSecondary text-gray-500 dark:text-gray-400',
                props.size === 'xs' ? 'text-xs' : 'text-sm',
                props.className
            )}
        >
            {props.children}
        </span>
    )
}

export const UiTableCellIconWrapper: React.FC<UiTableCellTextProps> = (
    props
) => {
    return (
        <div className="flex items-center gap-1.5 min-w-0">
            {props.children}
        </div>
    )
}
